export default {
	baseUrl: "https://3hpgvdbjkc.execute-api.eu-central-1.amazonaws.com/api",
	imagesHostUrl: "https://d1z64yrd5aplbu.cloudfront.net",
	imagesBucketName: "kitroengine-s3",
	userPoolId: "eu-central-1_ETOvg6QIX",
	userPoolWebClientId: "3i2cdih97t4kd8b89ffbfgilkh",
};
